module.exports = __webpack_public_path__ + "img/blue_153.037779ee.png";